import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ajaxSetup } from '@devexpress/analytics-core/analytics-utils';
import { AsyncExportApproach } from 'devexpress-reporting/scopes/reporting-viewer-settings';
import { environment } from '../../../../../../../environments/environment';

@Component({
    selector: 'app-report-designer',
    templateUrl: './report-designer.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: [
        './report-designer.component.scss',
        '../../../../../../../../node_modules/ace-builds/css/ace.css',
        '../../../../../../../../node_modules/ace-builds/css/theme/dreamweaver.css',
        '../../../../../../../../node_modules/ace-builds/css/theme/ambiance.css',
        '../../../../../../../../node_modules/devextreme/dist/css/dx.light.css',
        '../../../../../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.common.css',
        '../../../../../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.light.css',
        '../../../../../../../../node_modules/@devexpress/analytics-core/dist/css/dx-querybuilder.css',
        '../../../../../../../../node_modules/devexpress-reporting/dist/css/dx-webdocumentviewer.css',
        '../../../../../../../../node_modules/devexpress-reporting/dist/css/dx-reportdesigner.css',
    ],
    standalone: false
})
export class ReportDesignerComponent implements OnInit {
    title = 'DXReportDesignerSample';
    getDesignerModelAction = '/DXXRD/GetDesignerModel';
    reportName = 'TestReport';
    hostUrl = environment.reportApp;
    // hostUrl = 'https://localhost:44391';

    ngOnInit(): void {
        ajaxSetup.ajaxSettings = {
            headers: { Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}` },
            xhrFields: { withCredentials: true },
        };
        AsyncExportApproach(true);
    }
}
